export function getThumbnail(src: string) {
  let str = src.replace(/\/sites\/default\/files\//, '/sites/default/files/styles/medium/public/');
  str = str + '.webp';
  return str;
}

export function getStyle(src: string , style: string) { 
  let str = src.replace(/\/sites\/default\/files\//, '/sites/default/files/styles/'+style+'/public/');
  str = str + '.webp';
  return str;
}

export function pageOffset(page_limit: number, page_number: number) {
  return (page_number - 1) * page_limit
}

export function count(total: number, page_limit: number, currentPageNumber: number = 1) {
  const offset = pageOffset(page_limit, currentPageNumber)
  const totalPages = Math.ceil(total / page_limit)
  const currentPage = (offset / page_limit) + 1


  //display one page before and one page after the current page 
  return {
    totalPages: totalPages,
    currentPage: currentPage,
    previousPage: currentPage - 1,
    nextPage: currentPage + 1,
  }

}

export function stringSubstr(str: string, start: number, end: number) {
  if (str === null || str === '' || str === undefined) {
    return '';
  }
  if (str.length < end) {
    return str;
  }
  end = str.lastIndexOf('.', end);
  if (end === -1) {
    end = str.length;
  }
  return str.substr(start, end) + '.';
}